import { Role } from "@/lib/interfaces and Enums/ENUMRole";
import { ExecutionStrategy } from "@/lib/interfaces and Enums/InterfaceExecutionStrategy";
import { statusFromAwarded } from "../../../colDefs/colDefsShared";
import { ExecutionRequestStatus } from "@/lib/interfaces and Enums/ENUMExecutionRequestStatus";
import { ExecutionStrategyStatus } from "@/lib/interfaces and Enums/ENUMExecutionStrategyStatus";

export function confirmNPVandRecouponLegsInTrade(data: ExecutionStrategy): {
  containsNPV: boolean;
  containsRecoupon: boolean;
  totalBlockCount: number;
  NPVBlockCount: number;
  RecouponBlockCount: number;
} {
  let containsNPV = false;
  let containsRecoupon = false;
  let totalBlocks = 0;
  let NPVBlocks = 0;
  let RecouponBlocks = 0;
  // NO NPV STYLE - May change later to 'Unwind Pack - XXX'
  if (data.role == "OP") {
    if (
      data.executionRequestCounterParties &&
      data.executionRequestCounterParties.length > 0
    ) {
      if (
        data.executionRequestCounterParties[0].legs &&
        data.executionRequestCounterParties[0].legs.length > 0
      ) {
        data.executionRequestCounterParties[0].legs.forEach((leg) => {
          if (leg.unwind == "NPV") {
            containsNPV = true;
            NPVBlocks++;
          } else if (leg.unwind == "Recoupon") {
            containsRecoupon = true;
            RecouponBlocks++;
          }
          totalBlocks++;
        });
      }
    }
  } else if (data.role == "RP") {
    if (data.legs && data.legs.length > 0) {
      data.legs.forEach((leg) => {
        if (leg.unwind == "NPV") {
          containsNPV = true;
          NPVBlocks++;
        } else if (leg.unwind == "Recoupon") {
          containsRecoupon = true;
          RecouponBlocks++;
        }
        totalBlocks++;
      });
    }
  }

  return {
    containsNPV: containsNPV,
    containsRecoupon: containsRecoupon,
    totalBlockCount: totalBlocks,
    NPVBlockCount: NPVBlocks,
    RecouponBlockCount: RecouponBlocks,
  };
}

export function nameOfPrependedText(
  containsNPV: boolean,
  containsRecoupon: boolean,
  role: Role,
  status: ExecutionStrategyStatus | ExecutionRequestStatus | undefined,
): "Unwind" | "NPV" | "Recoupon" | "" {
  if (status == undefined) {
    return "";
  }
  if (containsNPV && containsRecoupon) {
    if (role == "OP") {
      return "Unwind";
    }
    if (role == "RP") {
      if (statusFromAwarded.includes(status)) {
        return "Unwind";
      }
    }
  }
  if (containsNPV) {
    return "NPV";
  }
  if (containsRecoupon) {
    return "Recoupon";
  }
  return "";
}

export function getFormattedStructureType(
  data: ExecutionStrategy,
  tradeData: ExecutionStrategy[],
): {
  formattedText: string;
  prependText: string;
  structureType: string;
} {
  // Try Zustand store first; fall back to row data itself (e.g. historical search)
  const thisTrade = tradeData.find((trade) => trade.esid == data.esid) ?? data;
  if (!data.role) {
    return {
      formattedText: data.structureType || "",
      prependText: "",
      structureType: data.structureType || "",
    };
  }

  const role: Role = data.role as Role;

  const { containsNPV, containsRecoupon } =
    confirmNPVandRecouponLegsInTrade(thisTrade);
  let appendTextForUnwindType = false;

  if (containsNPV) {
    appendTextForUnwindType = true;
  } else if (containsRecoupon) {
    if (role == Role.OP) {
      appendTextForUnwindType = true;
    } else if (role == Role.RP) {
      if (thisTrade?.status && statusFromAwarded.includes(thisTrade.status)) {
        appendTextForUnwindType = true;
      }
    }
  }

  const prependText = appendTextForUnwindType
    ? nameOfPrependedText(containsNPV, containsRecoupon, role, thisTrade.status)
    : "";
  const structureType = data.structureType || "";
  const formattedText = prependText
    ? `${prependText} - ${structureType}`
    : structureType;

  return {
    formattedText,
    prependText,
    structureType,
  };
}
